module.exports = __webpack_public_path__ + "img/20210619_171057.08ba38d9.jpg";